import model from 'modules/warehouse/warehouseModel';

const { fields } = model;

export default [
  fields.company,
  fields.street,
  fields.name,
];
